import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { CONSENT_EVENT, consentNeeded, initAnalytics, setConsent, trackPage } from "../../shared/lib/analytics";
import { captureProspectRef } from "../../shared/lib/prospectRef";
import s from "./analytics.module.scss";

captureProspectRef();
initAnalytics();

// One page_view per page change (GA4 itself is told not to send them)
export const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPage(location);
  }, [location]);
  return null;
};

// Europe only: analytics cookies wait for the visitor's choice
export const ConsentBanner = () => {
  const [open, setOpen] = useState(consentNeeded);
  useEffect(() => {
    const sync = () => setOpen(consentNeeded());
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);
  if (!open) return null;
  return (
    <div className={s.banner} role="dialog" aria-label="Cookies">
      <p>
        We use analytics cookies to understand how the site is used and make it better. No advertising.{" "}
        <a href="/privatePolicy">Privacy policy</a>
      </p>
      <div className={s.buttons}>
        <button type="button" className={s.ghost} onClick={() => setConsent(false)}>
          Decline
        </button>
        <button type="button" className={s.accept} onClick={() => setConsent(true)}>
          Accept
        </button>
      </div>
    </div>
  );
};
